import FieldSet from '../../FieldSet';
import { WorkDone } from './WorkDone';
import { WorkDoneWithIcon } from './WorkDoneWithIcon';

export class WorkDoneFieldSet extends FieldSet {
  get fieldDefinitions() {
    return [WorkDone, WorkDoneWithIcon];
  }

  get title() {
    return 'Work done';
  }
}
